import { render } from "./AddPage.vue?vue&type=template&id=0a739aa0"
import script from "./AddPage.vue?vue&type=script&lang=js"
export * from "./AddPage.vue?vue&type=script&lang=js"

import "./AddPage.vue?vue&type=style&index=0&id=0a739aa0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__